<template>
	<div class="difficultCompleteExchange" :class="{ 'ac-bg-black': ac }">
		<header-component
			:is-soon="false"
			img-left=""
			img-right="/trocachip/img/access.png"
			class="header-component"
			:backRoute="false"
		/>
		<div class="change_chip_container">
			<img src="img/icons/basic-circle-x.svg" id="icon_error" />
			<span
				class="difficultCompleteExchange_title"
				id="title_modal"
				:class="{ 'ac-color-white': ac }"
				v-html="difficultCompleteExchangePage.title"
			></span>
			<div class="difficultCompleteExchange_subtitle" id="subtitle_modal">
				<span v-html="description"></span>
			</div>
		</div>

		<footer class="difficultCompleteExchange_container-button">
			<button
				class="difficultCompleteExchange_button"
				@click="nextFlow(difficultCompleteExchangePage.firstButton.flow)"
				:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
			>
				{{ difficultCompleteExchangePage.firstButton.text }}
			</button>
		</footer>
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import { mapState } from 'vuex';

export default {
	name: 'difficultCompleteExchange',
	components: {
		HeaderComponent,
	},
	data() {
		return {
			description: '',
			// goToLastRoute: goToLastRoute
		};
	},
	computed: mapState({
		ac: (state) => state.ac,
		document: (state) => state.document,
		config: (state) => state.config,
		customer: (state) => state.customer,
		initFlow: (state) => state.config['init_flow'],
		difficultCompleteExchangePage: (state) =>
			state.config.difficultCompleteExchangePage || {},
	}),
	mounted() {
		this.description = this.$route.params.description;
	},
	methods: {
		nextFlow(flowSelected) {
			this.$store.commit('flowSelected', flowSelected);
			this.$router.push({ name: 'welcome' });
		},
	},
};
</script>

<style lang="scss">
.difficultCompleteExchange {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	.change_chip_container {
		width: 90%;
		height: auto;
		margin: 0 5%;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: content-box;
		> img {
			margin-top: 96px;
		}
	}
	.change_chip_email {
		width: 90%;
		height: auto;
		margin: 0 5%;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-sizing: content-box;
	}
	.difficultCompleteExchange_title {
		width: 309px;
		height: auto;
		font-family: 'timsans_bold';
		display: block;
		margin-block-end: 0 !important;
		margin-top: 24px;
		font-size: 18px;
		font-weight: 500;
		line-height: 27px;
		text-align: center;
		color: #000000;
	}
	.difficultCompleteExchange_container-button {
		width: 100%;
		height: auto;
		margin-top: 28px;
		position: fixed;
		bottom: 0;
		justify-content: center;
		display: grid;
		align-items: center;
	}
	.difficultCompleteExchange_button {
		width: 286px;
		height: 52px;
		margin: 0 auto 24px auto;
		border-radius: 26px;
		border: solid 2px #003091;
		background: none;
		outline: none;
		font-size: 1em;
		text-align: center;
		color: #003091;
		&:hover {
			cursor: pointer;
			-webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			-moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
			transition: 1s;
		}
	}
	.difficultCompleteExchange_subtitle {
		width: 309px;
		min-height: 48px;
		margin: 16px auto 23px auto;
		display: block;
		position: relative;
		font-family: 'timsans_regular';
		font-weight: 400;
		line-height: 21px;
		text-align: center;
		> span {
			width: 309px;
			height: 48px;
			font-size: 14px;
			font-stretch: normal;
			font-style: normal;
			letter-spacing: normal;
			color: #696969;
		}
	}
}
</style>
